import React, { memo } from "react";
import { areFilterPropsEqual } from "../helper";
import { DateTime } from "luxon";
import { format } from "date-fns";
import CalendarPicker from "app/components/OptionButtonGroup/CalendarPicker";
import styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";

type PropsDef = {
  title: string;
  value: string;
  queryName: string;
  onChange: (values: object) => void;
};

function SnapshotDateFilter(props: PropsDef) {
  const { title, value, queryName, onChange } = props;
  const { t } = useTranslation();

  const dateValue = value ? DateTime.fromISO(value).toJSDate() : new Date();

  const handleDateChange = (selectedDate: Date) => {
    onChange({ [queryName]: format(selectedDate, "yyyy-MM-dd") });
  };

  return (
    <div className={styles.filter_container}>
      <div className={styles.title}>{t(title)}</div>
      <div className={styles.calendar_picker_container}>
        <CalendarPicker
          date={dateValue}
          setDate={handleDateChange}
          customInput={true}
        />
      </div>
    </div>
  );
}

export default memo(SnapshotDateFilter, areFilterPropsEqual);
